import { render } from "./FlexiTraitsForm.vue?vue&type=template&id=49d6cd80"
import script from "./FlexiTraitsForm.vue?vue&type=script&lang=js"
export * from "./FlexiTraitsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__